var _path, _rect, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.955 14c.05.55-.4 1-.952 1H.997c-.552 0-1.002-.45-.952-1C.55 8.395 5.262 4 11 4s10.45 4.394 10.955 10",
    fill: "#AAA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#AAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 2,
    r: 2,
    fill: "#AAA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14,
    r: 5.5,
    fill: "#AAA",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 14.313 1.563 1.562 3.125-3.125",
    stroke: "#fff",
    strokeWidth: 0.781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishIcon);
export default __webpack_public_path__ + "static/media/DishIcon.a35470d5ef338f129473ee0eb8e24464.svg";
export { ForwardRef as ReactComponent };